// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-8b6b03fc],.fade-leave-active[data-v-8b6b03fc]{-webkit-transition:opacity .25s;transition:opacity .25s}.fade-enter[data-v-8b6b03fc],.fade-leave-to[data-v-8b6b03fc]{opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
